import { Link } from "react-router-dom";
import { useSettings } from "@/lib/settings";
import { API } from "@/lib/api";

export function Logo({ light = false, size = "md" }) {
  const settings = useSettings();
  const src = settings?.logo_url ? `${API}/files/${settings.logo_url}` : "/assets/logo-bawaslu-emblem.png";
  const wordCls = light ? "text-white" : "text-navy";
  const subCls = light ? "text-slate-300" : "text-slate-500";
  const dims = size === "sm" ? "h-9" : "h-11";
  return (
    <Link to="/" className="flex items-center gap-3 group" data-testid="brand-logo">
      <img src={src} alt="Logo Bawaslu" className={`${dims} w-auto shrink-0 drop-shadow-sm`} />
      <div className="leading-tight">
        <div className={`font-extrabold ${wordCls} text-base sm:text-lg`}>HARMONI BAWASLU</div>
        <div className={`text-[10px] sm:text-[11px] ${subCls} font-medium hidden sm:block`}>
          Satu Pintu Komunikasi Publik Bawaslu
        </div>
      </div>
    </Link>
  );
}
